import { useSelector } from 'react-redux'

import { getFullGenderString } from '~/components/common/inputs/gender/genderUtils'
import { getGender, getSpayedNeuteredStatus } from '~/store/reducers/constants'

export type FullGenderCellItem = {
  genderId: string
  spayedNeuteredId?: string
  spayedNeuteredStatusId: string
}

const FullGenderCell = (item: FullGenderCellItem) => {
  const Gender = useSelector(getGender)
  const SpayedNeuteredStatus = useSelector(getSpayedNeuteredStatus)

  const spayedNeuteredId =
    item?.spayedNeuteredId || item?.spayedNeuteredStatusId

  return (
    <>
      {getFullGenderString(
        item?.genderId,
        Gender,
        spayedNeuteredId,
        SpayedNeuteredStatus,
      )}
    </>
  )
}

export default FullGenderCell
